/**
 * Copyright © 2026 Adnuntius AS.
 */
import {isMissingTranslateKey, reportMissingTranslateKey} from './missing-translate-key';

export function adnTranslate(
  message: string,
  code: string,
  params: any,
  translateInstant: (key: string, params?: any) => string,
  interpolate: (template: string) => (params: any) => string
): string {
  // ngx-translate throws if key is null/undefined; many callers only set text
  // (sign-in validation, local UI strings). That is intentional — only report
  // when there is no plaintext fallback either.
  if (isMissingTranslateKey(code)) {
    if (isMissingTranslateKey(message)) {
      reportMissingTranslateKey({
        source: 'adnTranslate',
        key: code,
        missingField: 'code',
        interpolateParams: params,
        messageSummary: {
          text: message,
          paramKeys: params && typeof params === 'object' ? Object.keys(params) : undefined
        }
      });
    }
    return interpolate(message || '')(params);
  }
  const translation = translateInstant(code, params);
  return !translation || translation === code ? interpolate(message || '')(params) : translation;
}
